<template>
  <div class="container py-5">
    <!-- Header -->
    <div class="row mb-5">
      <div class="col-12 text-center">
        <h1 class="display-5 fw-bold mb-3">
          <i class="fas fa-plane text-primary me-3"></i>
          Cómo Llegar a Bolivia
        </h1>
        <p class="lead text-muted">Información práctica para planificar tu viaje</p>
      </div>
    </div>

    <!-- Aeropuertos principales -->
    <div class="row mb-5">
      <div class="col-12">
        <h3 class="mb-4">
          <i class="fas fa-plane-departure text-primary me-2"></i>
          Aeropuertos Principales
        </h3>
        <div class="row">
          <div class="col-lg-4 mb-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body text-center">
                <i class="fas fa-plane text-primary display-4 mb-3"></i>
                <h5 class="card-title">Aeropuerto Internacional El Alto</h5>
                <p class="card-text text-muted">La Paz, Bolivia</p>
                <div class="mt-3">
                  <span class="badge bg-primary me-2">Principal</span>
                  <span class="badge bg-info">4,100 msnm</span>
                </div>
                <p class="mt-3 small text-muted">
                  El aeropuerto más alto del mundo, ubicado en La Paz.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body text-center">
                <i class="fas fa-plane text-success display-4 mb-3"></i>
                <h5 class="card-title">Aeropuerto Internacional Viru Viru</h5>
                <p class="card-text text muted">Santa Cruz, Bolivia</p>
                <div class="mt-3">
                  <span class="badge bg-success me-2">Internacional</span>
                  <span class="badge bg-info">400 msnm</span>
                </div>
                <p class="mt-3 small text-muted">
                  Principal aeropuerto de Santa Cruz, con vuelos internacionales.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 mb-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body text-center">
                <i class="fas fa-plane text-warning display-4 mb-3"></i>
                <h5 class="card-title">Aeropuerto Internacional Jorge Wilstermann</h5>
                <p class="card-text text-muted">Cochabamba, Bolivia</p>
                <div class="mt-3">
                  <span class="badge bg-warning me-2">Nacional</span>
                  <span class="badge bg-info">2,500 msnm</span>
                </div>
                <p class="mt-3 small text-muted">
                  Aeropuerto principal de Cochabamba, en el corazón de Bolivia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Documentación requerida -->
    <div class="row mb-5">
      <div class="col-lg-8">
        <h3 class="mb-4">
          <i class="fas fa-passport text-primary me-2"></i>
          Documentación Requerida
        </h3>
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm">
              <div class="card-body">
                <h6 class="card-title">
                  <i class="fas fa-globe-americas text-success me-2"></i>
                  Ciudadanos de Países Vecinos
                </h6>
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Cédula de identidad válida
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Pasaporte (opcional)
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Sin visa requerida
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm">
              <div class="card-body">
                <h6 class="card-title">
                  <i class="fas fa-plane text-primary me-2"></i>
                  Ciudadanos de Otros Países
                </h6>
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Pasaporte válido (mínimo 6 meses)
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Visa turística (según país)
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Pasaje de salida
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-lg-4">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <h5 class="card-title">
              <i class="fas fa-info-circle text-primary me-2"></i>
              Información Importante
            </h5>
            <ul class="list-unstyled">
              <li class="mb-3">
                <i class="fas fa-clock text-warning me-2"></i>
                <strong>Duración de estadía:</strong><br>
                <small class="text-muted">Hasta 90 días para turistas</small>
              </li>
              <li class="mb-3">
                <i class="fas fa-money-bill text-success me-2"></i>
                <strong>Moneda:</strong><br>
                <small class="text-muted">Boliviano (Bs)</small>
              </li>
              <li class="mb-3">
                <i class="fas fa-language text-info me-2"></i>
                <strong>Idiomas:</strong><br>
                <small class="text-muted">Español, Quechua, Aymara</small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Consejos de viaje -->
    <div class="row mb-5">
      <div class="col-12">
        <h3 class="mb-4">
          <i class="fas fa-lightbulb text-warning me-2"></i>
          Consejos de Viaje
        </h3>
        <div class="row">
          <div class="col-md-4 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body text-center">
                <i class="fas fa-calendar-alt text-primary display-4 mb-3"></i>
                <h5 class="card-title">Mejor Época</h5>
                <p class="card-text">
                  Mayo a Octubre (temporada seca) es la mejor época para visitar Bolivia.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body text-center">
                <i class="fas fa-thermometer-half text-info display-4 mb-3"></i>
                <h5 class="card-title">Aclimatación</h5>
                <p class="card-text">
                  Tómate tu tiempo para aclimatarte a la altura, especialmente en La Paz.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body text-center">
                <i class="fas fa-shield-alt text-success display-4 mb-3"></i>
                <h5 class="card-title">Seguridad</h5>
                <p class="card-text">
                  Bolivia es un país seguro, pero siempre toma precauciones básicas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transporte terrestre internacional -->
    <div class="row mb-5">
      <div class="col-12">
        <h3 class="mb-4">
          <i class="fas fa-route text-primary me-2"></i>
          Transporte Terrestre Internacional
        </h3>
        <p class="lead text-muted mb-4">Rutas terrestres desde países vecinos hacia Bolivia</p>
        
        <div class="row">
          <div class="col-lg-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-primary text-white">
                <h5 class="mb-0">
                  <i class="fas fa-flag text-warning me-2"></i>
                  Desde Perú
                </h5>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <h6 class="text-primary">Terminal de Desaguadero</h6>
                  <p class="small text-muted">Frontera Perú-Bolivia</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Puno → Desaguadero → La Paz
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 8-10 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $15-25 USD
                    </li>
                  </ul>
                </div>
                <div>
                  <h6 class="text-primary">Terminal de Copacabana</h6>
                  <p class="small text-muted">Lago Titicaca</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Cusco → Puno → Copacabana → La Paz
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 12-15 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $20-30 USD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-lg-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-success text-white">
                <h5 class="mb-0">
                  <i class="fas fa-flag text-warning me-2"></i>
                  Desde Chile
                </h5>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <h6 class="text-success">Terminal de Arica</h6>
                  <p class="small text-muted">Frontera Chile-Bolivia</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Arica → Tambo Quemado → La Paz
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 10-12 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $25-35 USD
                    </li>
                  </ul>
                </div>
                <div>
                  <h6 class="text-success">Terminal de Calama</h6>
                  <p class="small text-muted">Ruta del Desierto</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Calama → San Pedro de Atacama → Uyuni
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 8-10 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $20-30 USD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-lg-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-warning text-dark">
                <h5 class="mb-0">
                  <i class="fas fa-flag text-warning me-2"></i>
                  Desde Argentina
                </h5>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <h6 class="text-warning">Terminal de La Quiaca</h6>
                  <p class="small text-muted">Frontera Argentina-Bolivia</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Jujuy → La Quiaca → Villazón → Tarija
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 6-8 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $15-25 USD
                    </li>
                  </ul>
                </div>
                <div>
                  <h6 class="text-warning">Terminal de Salta</h6>
                  <p class="small text-muted">Ruta del Norte</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Salta → La Quiaca → Potosí
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 12-15 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $25-35 USD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-lg-6 mb-4">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-info text-white">
                <h5 class="mb-0">
                  <i class="fas fa-flag text-warning me-2"></i>
                  Desde Brasil
                </h5>
              </div>
              <div class="card-body">
                <div class="mb-3">
                  <h6 class="text-info">Terminal de Corumbá</h6>
                  <p class="small text-muted">Frontera Brasil-Bolivia</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> São Paulo → Corumbá → Puerto Suárez → Santa Cruz
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 24-30 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $40-60 USD
                    </li>
                  </ul>
                </div>
                <div>
                  <h6 class="text-info">Terminal de Guayaramerín</h6>
                  <p class="small text-muted">Frontera Norte</p>
                  <ul class="list-unstyled">
                    <li class="mb-2">
                      <i class="fas fa-bus text-success me-2"></i>
                      <strong>Ruta:</strong> Manaus → Guayaramerín → Riberalta
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-clock text-info me-2"></i>
                      <strong>Duración:</strong> 18-24 horas
                    </li>
                    <li class="mb-2">
                      <i class="fas fa-money-bill text-warning me-2"></i>
                      <strong>Precio:</strong> $35-50 USD
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Transporte interno -->
    <div class="row">
      <div class="col-12">
        <h3 class="mb-4">
          <i class="fas fa-bus text-primary me-2"></i>
          Transporte Interno
        </h3>
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm">
              <div class="card-body">
                <h5 class="card-title">
                  <i class="fas fa-plane text-primary me-2"></i>
                  Vuelos Domésticos
                </h5>
                <p class="card-text">
                  Conexiones aéreas entre las principales ciudades. Recomendado para distancias largas.
                </p>
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    La Paz ↔ Santa Cruz
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    La Paz ↔ Cochabamba
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Santa Cruz ↔ Sucre
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="card border-0 shadow-sm">
              <div class="card-body">
                <h5 class="card-title">
                  <i class="fas fa-bus text-success me-2"></i>
                  Buses
                </h5>
                <p class="card-text">
                  Red extensa de buses que conectan todo el país. Económico pero más lento.
                </p>
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Conexiones a todas las ciudades
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Variedad de precios y comodidades
                  </li>
                  <li class="mb-2">
                    <i class="fas fa-check text-success me-2"></i>
                    Ideal para conocer el paisaje
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComoLlegar'
}
</script>

<style scoped>
.card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15) !important;
}

.display-4 {
  font-size: 3rem;
}

@media (max-width: 768px) {
  .display-4 {
    font-size: 2rem;
  }
}
</style> 